import React from 'react';
import UserManagement from '../modules/User/UserManagement';

function UserPage() {
    return <UserManagement />;
}

export default UserPage;
